'use client';

import Link from 'next/link';

import CoverOverlay from '../../components/cover/CoverOverlay';
import StaggerReveal from '../../components/StaggerReveal';
import { coverLabel } from '../../../lib/coverLabel';
import { getSiteConfig } from '../../../config/sites';

import styles from './destination.module.scss';
import collectionStyles from '../../collections/collections.module.scss';

const EMPTY_LABEL = `Няма налични корици за тази ${getSiteConfig().content.taxonomyNoun}.`;

export default function DestinationPageClient({ destination, description }) {
  const templates = destination?.templates ?? [];
  const slug = destination?.slug ?? '';

  return (
    <div data-destination-page>
      {description && <p className={styles.description}>{description}</p>}

      {templates.length === 0 ? (
        <p className={styles.placeholderDescription}>{EMPTY_LABEL}</p>
      ) : (
        <StaggerReveal>
          <ul
            className={`${collectionStyles.destinationGrid} ${collectionStyles.staggerRevealTarget}`}
          >
            {templates.map((template, index) => {
              const label = coverLabel(template, index, destination?.name);
              const href = `/destinations/${encodeURIComponent(slug)}/${template.coverSlug ?? index}`;
              return (
                <li key={template.id ?? index}>
                  <Link href={href} className={collectionStyles.destinationCard} aria-label={label}>
                    <CoverOverlay
                      template={template}
                      destinationName={destination?.name}
                      size="md"
                      imageLoading={index < 6 ? 'eager' : 'lazy'}
                      placeholderChar={destination?.name?.charAt(0) ?? '?'}
                      showCatalogBadges
                      showFavoriteButton
                      favoriteSlug={slug}
                      favoriteTemplateId={template.templateId}
                    />
                  </Link>
                </li>
              );
            })}
          </ul>
        </StaggerReveal>
      )}
    </div>
  );
}
